import React, { useRef } from 'react'
import { useSelector } from 'react-redux'
import { RootReducer } from '../../redux/rootReducer'
import Layout from '../layout/Layout'
import { SearchSvg } from '../other/svg/Index'
import { useTranslation } from 'react-i18next'
import OfferFilters from '../molecules/OfferFilters'
import InfinitiveGrid from './InfinitiveGrid'
import PaginatedOffersBrowse from './PaginatedOffersBrowse'

const Browse = (): JSX.Element => {
  const { t } = useTranslation()
  const containerRef = useRef<HTMLDivElement>(null)
  const { paginationType } = useSelector((state: RootReducer) => state.layoutReducer)
  const { tab } = useSelector((state: RootReducer) => state.offersListReducer)

  return (
    <div>
      <Layout
        withoutToolbar={false}
        iconComponent={<SearchSvg className="w-8 text-white" />}
        withFiler={true}
        name={t('all_vehicles')}>
        <div className="h-full" ref={containerRef}>
          <OfferFilters containerRef={containerRef} />
          {paginationType === 'infinite' && <InfinitiveGrid />}
          {paginationType === 'paginated' && tab === 'browse' && <PaginatedOffersBrowse />}
        </div>
      </Layout>
    </div>
  )
}

export default Browse
